
// panel-wrapper.component.ts
import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { FieldWrapper } from '@ngx-formly/core';
import PrettySequenceHelper from '../../../shared/form-builder-util/pretty-sequence';

@Component({
  selector: 'formly-section-wrapper',
  templateUrl: './widgets-section-wrapper.component.html',
  styleUrls: ['./widgets-section-wrapper.component.scss']
})
export class WidgetsSectionWrapperComponent extends FieldWrapper implements OnInit {
  // A variable called to is automatically exposed as part of the FieldWrapper extended class
  // Meaning: props
  // All attributes defined as template options can be read like that (to.sequence, to.label,...)

  public sequence: string = '';
  showQuestion: string = '';
  isContainerExpanded: boolean = false;

  ngOnInit(): void {
    if (!this.to.seqHidden) {
      this.sequence = PrettySequenceHelper.formatSequence(this.to.sequence) + " - ";
      if (this.to.sequence == '1') {
        this.isContainerExpanded = true;
      } else {
        this.isContainerExpanded = false;
      }
    }
  }

  onSectionCollapse(): void {
    this.isContainerExpanded = false;
  }

  onSectionExpand(): void {
    this.isContainerExpanded = true;
  }
}